export default __webpack_public_path__ + "static/media/untold.0580ce7b.jpeg";